var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwissbounds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M26.674 11.952l-2.026 2.614-7.528 2.052-1.48-.8-4.88 3.626 2.206.758L7.16 26.64 5 34.548l4.28-1.088 1.89-1.1 4.474 4.282 6.314-.708 3.638-3.938 4.306 5.956 3.148-6.676 7.328 1.914-.464-4.006 3.086.078-.316-6.538-2.686-2.052-.872 1.654-3.552-1.072 1.326-3.952-7.434-2.886z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwissbounds);
export default __webpack_public_path__ + "static/media/swissbounds.249da0eccb5d7c3f331117f9ddeb5969.svg";
export { ForwardRef as ReactComponent };